import { CompetitionsAddForm } from "./competitions-add-form";

export function CompetitionsAdd() {
  return (
    <div className="p-8">
      <CompetitionsAddForm />
    </div>
  );
}
